import React from 'react';
import LazyLoad from 'Common/pages/LazyLoad';

const withWaitingComponent = (Component: React.ComponentType) => (
  <LazyLoad>
    <Component />
  </LazyLoad>
);
export default withWaitingComponent;
